/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationExtTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="SingleSizeIllustrationExtTick"
    role="presentation"
    {...props}
  >
    <circle cx={12} cy={12} r={12} fill="#00D296" />
    <path
      fill="#005357"
      d="m18.423 8.613-1.177-1.176-7 7-3.5-3.5-1.177 1.176 4.677 4.677z"
    />
  </svg>
);
export default SingleSizeIllustrationExtTick;
